import { Link } from "react-router";
import { GameVer, tturl, useRealm } from "~/util/Lang";

export type LocLinkData = {
  name: string;
  locName: string;
  gver?: GameVer;
};

export function LocLink(props: { loc: LocLinkData }) {
  const realm = useRealm();

  return (
    <Link
      to={tturl(
        { lang: realm.lang, game: props.loc.gver ?? realm.game },
        "/locs/" + props.loc.locName,
      )}
    >
      {props.loc.name}
    </Link>
  );
}
